/* eslint-disable */
import { GeneralClass, goMock, initPost } from './../../../../../../api';
import type { ErrorException, PowerPartial } from './../../../../../../api';
import type {
  QueryRoleListReq,
  QueryRoleListRsp,
} from './../../../../../../git.woa.com/itrpcprotocol/pmdtrpc/commcgi/tipcgi/tipcgi/QueryRoleList';

const ADDRESS_NAME = '/pmdtrpc.commcgi.tipcgi.tipcgi/'


export class QueryRoleListService extends GeneralClass {
  QueryRoleList(payload: PowerPartial<QueryRoleListReq>, options?: any): Promise<[QueryRoleListRsp, ErrorException?]> {
    return new Promise((resolve, reject) => {
      if (options?.mock) {
        goMock({methodName: 'QueryRoleList', addressName: ADDRESS_NAME, payload, options, resolve, reject });
        return;
      }
      this.generalRequestMethod<typeof payload,QueryRoleListRsp>('QueryRoleList', payload, options).then((res) => {
        resolve([res]);
      })
        .catch((error) => {
        	if (options?.alwaysResolve) {
        		resolve([{} as QueryRoleListRsp, error]);
        	} else {
        		reject(error);
        	}
        });
    });
  };
};



const QueryRoleListClient = new QueryRoleListService(initPost(ADDRESS_NAME), ADDRESS_NAME);
export { QueryRoleListClient };
